import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AIReports() {
  const [periodo, setPeriodo] = useState("settimanale");
  const [cantiereId, setCantiereId] = useState("");
  const [cantieri, setCantieri] = useState([]);
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const [c, r] = await Promise.all([api.get("/cantieri"), api.get("/ai/reports")]);
    setCantieri(c.data); setList(r.data);
  };
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setBusy(true);
    try {
      await api.post("/ai/report", { periodo, cantiere_id: cantiereId || null });
      toast.success("Report generato con AI!");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore AI"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Intelligenza Artificiale</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">Report AI Automatici</h1>
        <p className="text-muted-foreground mt-1">Claude Sonnet analizza i tuoi dati e genera report professionali in italiano.</p>
      </div>

      <Card className="card-elevated">
        <CardContent className="p-5 flex flex-wrap items-end gap-3">
          <div>
            <Label>Periodo</Label>
            <Select value={periodo} onValueChange={setPeriodo}>
              <SelectTrigger data-testid="ai-periodo" className="w-48"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="settimanale">Ultima settimana</SelectItem>
                <SelectItem value="mensile">Ultimo mese</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Cantiere (opzionale)</Label>
            <Select value={cantiereId || "__all__"} onValueChange={(v) => setCantiereId(v === "__all__" ? "" : v)}>
              <SelectTrigger data-testid="ai-cantiere" className="w-64"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">Tutti i cantieri</SelectItem>
                {cantieri.map((c) => <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <Button data-testid="ai-generate" onClick={generate} disabled={busy} className="h-11">
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
            Genera report AI
          </Button>
        </CardContent>
      </Card>

      <div className="space-y-4">
        {list.map((r) => (
          <Card key={r.id} className="card-elevated">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <Badge className="badge-tag"><Sparkles className="h-3 w-3 mr-1" /> {r.periodo}</Badge>
                <span className="text-xs text-muted-foreground">{new Date(r.created_at).toLocaleString("it-IT")}</span>
              </div>
              <div className="prose prose-sm max-w-none whitespace-pre-line text-foreground">
                {r.report}
              </div>
            </CardContent>
          </Card>
        ))}
        {list.length === 0 && <div className="text-muted-foreground py-12 text-center">Nessun report generato ancora.</div>}
      </div>
    </div>
  );
}
